<template lang="pug">
.parts-markup-popup
	button.parts-markup-popup__close(@click="$emit('close', $event)")
	.parts-markup-popup__nav
		slot(name="nav")
	slot
</template>

<script>
export default {
  props: {
    current: String
  }
}
</script>

<style lang="scss" scoped>

.parts-markup-popup {
  width: 100%;
  position: relative;

	&__nav {
		padding-bottom: 15px;
	}

  &__close {

    @media only screen and (max-width: 40em){
      top: 40px;
    }

		display: block;
		position: absolute;
		top: 15px;
		right: 0;
		width: 15px;
		height: 15px;
		background-color: transparent;
		border-width: 0;
		cursor: pointer;
    z-index: 20;

		&:before,
		&:after {
			position: absolute;
			top: 6px;
			left: -1px;
			width: 17px;
			height: 3px;
			content: '';
			background-color: #646464;
			transition: background-color .3s ease;
		}

		&:before {
			transform: rotate(45deg);
		}

		&:after {
			transform: rotate(-45deg);
		}

		&:active,
		&:focus,
		&:hover {
			outline: 0;
		}

		&:hover {
			&:before,
			&:after {
				background-color: #e25a5a;
			}
		}

		&:active,
		&:focus {
			&:before,
			&:after {
				background-color: rgba(0, 0, 0, 0.85);
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// Popup.vue?23e612da